import { createAction } from '@reduxjs/toolkit';
import { IErrorType } from '../../constants/types';
import type {
    IUserMediaAsset,
    IUserMediaPagination,
    IUserMediaUploadMeta,
    UserMediaCategory,
} from '../../types/global/userMedia.types';

export const types = {
    LIST_USER_MEDIA_ASSETS: 'LIST_USER_MEDIA_ASSETS',
    LIST_USER_MEDIA_ASSETS_SUCCESS: 'LIST_USER_MEDIA_ASSETS_SUCCESS',
    LIST_USER_MEDIA_ASSETS_FAIL: 'LIST_USER_MEDIA_ASSETS_FAIL',
    PREPEND_USER_MEDIA_ASSET: 'PREPEND_USER_MEDIA_ASSET',
    UPDATE_USER_MEDIA_ASSET: 'UPDATE_USER_MEDIA_ASSET',
    UPDATE_USER_MEDIA_ASSET_SUCCESS: 'UPDATE_USER_MEDIA_ASSET_SUCCESS',
    UPDATE_USER_MEDIA_ASSET_FAIL: 'UPDATE_USER_MEDIA_ASSET_FAIL',
    DELETE_USER_MEDIA_ASSET: 'DELETE_USER_MEDIA_ASSET',
    DELETE_USER_MEDIA_ASSET_SUCCESS: 'DELETE_USER_MEDIA_ASSET_SUCCESS',
    DELETE_USER_MEDIA_ASSET_FAIL: 'DELETE_USER_MEDIA_ASSET_FAIL',
    CLEAR_USER_MEDIA_ASSETS: 'CLEAR_USER_MEDIA_ASSETS',
    UPLOAD_USER_MEDIA_LIBRARY_IMAGE: 'UPLOAD_USER_MEDIA_LIBRARY_IMAGE',
    UPLOAD_USER_MEDIA_LIBRARY_IMAGE_SUCCESS: 'UPLOAD_USER_MEDIA_LIBRARY_IMAGE_SUCCESS',
    UPLOAD_USER_MEDIA_LIBRARY_IMAGE_FAIL: 'UPLOAD_USER_MEDIA_LIBRARY_IMAGE_FAIL',
} as const;

export interface IListUserMediaAssetsPayload {
    page?: number;
    limit?: number;
    q?: string;
    append?: boolean;
    force?: boolean;
}

export interface IListUserMediaAssetsSuccessPayload {
    assets: IUserMediaAsset[];
    pagination: IUserMediaPagination;
    append: boolean;
    cacheKey: string;
    q: string;
}

export interface IUpdateUserMediaAssetPayload {
    id: string;
    meta: IUserMediaUploadMeta;
}

export const listUserMediaAssets = createAction<IListUserMediaAssetsPayload>(types.LIST_USER_MEDIA_ASSETS);
export const listUserMediaAssetsSuccess = createAction<IListUserMediaAssetsSuccessPayload>(
    types.LIST_USER_MEDIA_ASSETS_SUCCESS,
);
export const listUserMediaAssetsFail = createAction<IErrorType>(types.LIST_USER_MEDIA_ASSETS_FAIL);
export const prependUserMediaAsset = createAction<IUserMediaAsset>(types.PREPEND_USER_MEDIA_ASSET);

export const updateUserMediaAsset = createAction<IUpdateUserMediaAssetPayload>(types.UPDATE_USER_MEDIA_ASSET);
export const updateUserMediaAssetSuccess = createAction<IUserMediaAsset>(types.UPDATE_USER_MEDIA_ASSET_SUCCESS);
export const updateUserMediaAssetFail = createAction<IErrorType>(types.UPDATE_USER_MEDIA_ASSET_FAIL);

export const deleteUserMediaAsset = createAction<string>(types.DELETE_USER_MEDIA_ASSET);
export const deleteUserMediaAssetSuccess = createAction<string>(types.DELETE_USER_MEDIA_ASSET_SUCCESS);
export const deleteUserMediaAssetFail = createAction<IErrorType>(types.DELETE_USER_MEDIA_ASSET_FAIL);

export const clearUserMediaAssets = createAction(types.CLEAR_USER_MEDIA_ASSETS);

export interface IUploadUserMediaLibraryImagePayload {
    file: File;
    category?: UserMediaCategory;
    name?: string;
    tags?: string[];
    description?: string;
}

export type IUploadUserMediaLibraryImageResult = { url: string; asset: IUserMediaAsset };

export const uploadUserMediaLibraryImage = createAction<IUploadUserMediaLibraryImagePayload>(
    types.UPLOAD_USER_MEDIA_LIBRARY_IMAGE,
);
export const uploadUserMediaLibraryImageSuccess = createAction<IUploadUserMediaLibraryImageResult>(
    types.UPLOAD_USER_MEDIA_LIBRARY_IMAGE_SUCCESS,
);
export const uploadUserMediaLibraryImageFail = createAction<IErrorType>(types.UPLOAD_USER_MEDIA_LIBRARY_IMAGE_FAIL);
